'use client';

import { DEFAULT_VARIANTS_ASSET_VIEWER } from './constants';
import { PanelBase, PanelIndicator } from './PanelBase';
import type { AnimatedIconProps } from './types';

/**
 * @description Animated icon showing the visible or selected states of the asset viewer panel
 */
export const AnimatedIconAssetViewer = ({
  $isSelected,
  variants = DEFAULT_VARIANTS_ASSET_VIEWER,
  ...props
}: AnimatedIconProps) => (
  <PanelBase {...props}>
    <PanelIndicator
      $isSelected={$isSelected}
      height="10"
      variants={variants}
      y="7"
    />
  </PanelBase>
);
